"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VDateTimePicker = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@blueprintjs/core");
var datetime_1 = require("@blueprintjs/datetime");
var mobx_react_1 = require("mobx-react");
var moment_1 = __importDefault(require("moment"));
require("moment/locale/en-gb");
require("moment/locale/es");
require("moment/locale/fr");
var moment_2 = __importDefault(require("react-day-picker/moment"));
var Validators_1 = require("../Validators");
var FormFieldContainer_1 = require("./FormFieldContainer");
var style_1 = require("./style");
var momentFormatter = function (format) {
    return {
        formatDate: function (date) { return (0, moment_1.default)(date).format(format); },
        parseDate: function (str, locale) {
            return (0, moment_1.default)(str, format)
                .locale(locale)
                .toDate();
        },
        placeholder: "".concat(format)
    };
};
var toDate = function () {
    return (0, moment_1.default)().toDate();
};
var toDateNotSelect = function (date) {
    return (0, moment_1.default)((0, moment_1.default)().toDate()).isSame((0, moment_1.default)(date), 'd');
};
var outOfRangeError = function (date, value, type) {
    if (type === 'MIN') {
        return (0, moment_1.default)(value).isBefore((0, moment_1.default)(date), 'd');
    }
    return (0, moment_1.default)(value).isAfter((0, moment_1.default)(date), 'd');
};
exports.VDateTimePicker = (0, mobx_react_1.observer)(function (props) {
    var label = props.label, labelInfo = props.labelInfo, fieldState = props.fieldState, disabled = props.disabled, inline = props.inline, id = props.id, className = props.className, layer = props.layer, fill = props.fill, dateType = props.dateType, rightElement = props.rightElement, icon = props.icon, margin = props.margin, value = props.value, noLabel = props.noLabel, required = props.required, popoverProps = props.popoverProps, dayPickerProps = props.dayPickerProps, maxTime = props.maxTime, minTime = props.minTime, useAmPm = props.useAmPm, precision = props.precision, validators = props.validators, displayRequired = props.displayRequired, tooltip = props.tooltip, format = props.format, onChange = props.onChange, canClearSelection = props.canClearSelection, shortcuts = props.shortcuts, showActionsBar = props.showActionsBar, _a = props.locale, locale = _a === void 0 ? 'en' : _a, _b = props.clearButtonText, clearButtonText = _b === void 0 ? 'Clear' : _b, _c = props.todayButtonText, todayButtonText = _c === void 0 ? 'Today' : _c;
    var dateRef = (0, react_1.useRef)(null);
    var isFocused = (0, react_1.useRef)();
    var _d = (0, react_1.useState)(), minTimeCalculate = _d[0], setMinTimeCalculate = _d[1];
    var _e = (0, react_1.useState)(), maxTimeCalculate = _e[0], setMaxTimeCalculate = _e[1];
    var _f = (0, react_1.useState)(toDate()), defaultValue = _f[0], setDefaultValue = _f[1];
    var _g = (0, react_1.useState)(), valueField = _g[0], setValueField = _g[1];
    (0, react_1.useEffect)(function () {
        calculateValue();
    }, [fieldState === null || fieldState === void 0 ? void 0 : fieldState.value, value]);
    (0, react_1.useEffect)(function () {
        setDefaultValue(minTime ? minTime : maxTime ? maxTime : toDate());
    }, [minTime, maxTime]);
    (0, react_1.useEffect)(function () {
        if (fieldState) {
            if (required) {
                if (validators && validators.length > 0) {
                    fieldState.validators.apply(fieldState, __spreadArray([Validators_1.Validators.required], validators, false));
                }
                else {
                    fieldState.validators(Validators_1.Validators.required);
                }
            }
            else if (validators && validators.length > 0) {
                fieldState.validators.apply(fieldState, validators);
            }
        }
    }, [fieldState]);
    (0, react_1.useEffect)(function () {
        setMinTimeCalculate(minTime
            ? outOfRangeError(minTime, valueField, 'MIN')
                ? (0, moment_1.default)('1/1/1900').toDate()
                : minTime
            : (0, moment_1.default)('1/1/1900').toDate());
    }, [minTime, valueField]);
    (0, react_1.useEffect)(function () {
        setMaxTimeCalculate(maxTime
            ? outOfRangeError(maxTime, valueField, 'MAX')
                ? (0, moment_1.default)('1/1/2100').toDate()
                : maxTime
            : (0, moment_1.default)('1/1/2100').toDate());
    }, [maxTime, valueField]);
    var calculateValue = function () {
        if (dateType === 'TIME' &&
            ((!value && fieldState && !fieldState.value) || (!value && !fieldState))) {
            setValueField(new Date(0, 0, 0, 0, 0, 0));
            return;
        }
        if ((dateType === 'DATE' || dateType === 'DATETIME') &&
            !value &&
            !fieldState) {
            setValueField(null);
            return;
        }
        if (fieldState) {
            setValueField((0, moment_1.default)(fieldState.value).isValid()
                ? (0, moment_1.default)(fieldState.value).toDate()
                : null);
            return;
        }
        if (value) {
            setValueField((0, moment_1.default)(value).isValid() ? (0, moment_1.default)(value).toDate() : null);
            return;
        }
    };
    var FORMATS = function () {
        return {
            DATE: momentFormatter(format || dFormat()['DATE']),
            DATETIME: momentFormatter("".concat(format || dFormat()['DATETIME'])),
            TIME: momentFormatter(dFormat()['TIME'])
        };
    };
    var dFormat = function () {
        return {
            DATE: 'MM/DD/YYYY',
            DATETIME: 'MM/DD/YYYY HH:mm:ss',
            TIME: 'HH:mm:ss'
        };
    };
    var changeDate = function (date) {
        if ((0, moment_1.default)(date, format || dFormat()[dateType]).isValid() ||
            date === null) {
            if (fieldState) {
                fieldState.onChange(date);
            }
            if (onChange) {
                onChange(date);
            }
        }
    };
    var changedDate = function (date) {
        if (!!closeOnSelection || props.dateType === 'TIME') {
            changeDate(date);
        }
        else {
            setValueField(date);
        }
    };
    var onClosed = function () {
        if (!closeOnSelection && !closeOnSelection !== undefined) {
            changeDate(valueField);
        }
    };
    var iconJSX = function () {
        if (icon) {
            return (react_1.default.createElement(style_1.IconDate, { backgroundColor: icon.backgroundColor, onClick: function (e) {
                    var _a;
                    e.stopPropagation();
                    if (isFocused && !isFocused.current) {
                        (_a = dateRef === null || dateRef === void 0 ? void 0 : dateRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                    }
                } },
                react_1.default.createElement(core_1.Icon, { color: icon.color, icon: icon.iconName, iconSize: icon.size || 16 })));
        }
        return rightElement;
    };
    var modifiers = { toDateNotSelect: toDateNotSelect };
    var closeOnSelection = (0, react_1.useMemo)(function () {
        if (props.closeOnSelection === undefined && props.dateType === 'DATETIME') {
            return false;
        }
        return props.closeOnSelection;
    }, [props.closeOnSelection, props.dateType]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(style_1.StyledDatePicker, __assign({}, {
            className: className,
            disabled: disabled,
            inline: inline,
            labelInfo: labelInfo,
            layer: layer,
            fill: fill,
            margin: margin,
            noLabel: noLabel
        }, { intent: fieldState && fieldState.hasError ? core_1.Intent.DANGER : core_1.Intent.NONE, labelFor: id }),
            react_1.default.createElement(FormFieldContainer_1.FormFieldContainer, __assign({}, { noLabel: noLabel, label: label, fieldState: fieldState, value: value, tooltip: tooltip }, { required: required || displayRequired }),
                props.tipLabel && (react_1.default.createElement("span", { className: 'tipLabel' }, props.tipLabel)),
                dateType === 'DATETIME' || dateType === 'DATE' ? (react_1.default.createElement(style_1.DateInputContainer, __assign({}, FORMATS()[dateType], {
                    locale: locale,
                    disabled: disabled,
                    defaultValue: defaultValue,
                    canClearSelection: canClearSelection,
                    closeOnSelection: closeOnSelection,
                    shortcuts: shortcuts,
                    showActionsBar: showActionsBar,
                    modifiers: modifiers,
                    clearButtonText: clearButtonText,
                    todayButtonText: todayButtonText
                }, { localeUtils: moment_2.default, minDate: minTimeCalculate, popoverProps: __assign(__assign({ shouldReturnFocusOnClose: false, captureDismiss: true, minimal: true }, popoverProps), { onClosed: onClosed }), maxDate: maxTimeCalculate, onChange: changedDate, value: valueField, timePrecision: dateType === 'DATETIME' ? precision : undefined, rightElement: iconJSX(), dayPickerProps: __assign({ fixedWeeks: true }, dayPickerProps), timePickerProps: dateType === 'DATETIME' ? { useAmPm: useAmPm } : undefined, inputProps: {
                        inputRef: function (element) {
                            dateRef.current = element;
                        },
                        onFocus: function () {
                            isFocused.current = true;
                            if (props.onFocus) {
                                props.onFocus();
                            }
                        },
                        onBlur: function () {
                            isFocused.current = false;
                            if (props.onBlur) {
                                props.onBlur();
                            }
                        }
                    } }))) : (react_1.default.createElement(datetime_1.TimePicker, { value: valueField, useAmPm: useAmPm || false, precision: precision || 'second', onChange: changedDate, disabled: disabled }))))));
});
